import React from "react";
import { Tooltip as AntdTooltip } from "antd";

const ToolTip = ({ placement, title, children }) => {
  return (
    <AntdTooltip placement={placement} title={title}>
      {children}
    </AntdTooltip>
  );
};

export default ToolTip;
